import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import qs from 'qs'

import { AppSegment } from 'client/ui-building-blocks'
import { GenericError, Question } from 'client/components'
import { QuestionContextMenu } from 'client/components/Question'
import { useQuestion } from 'client/hooks'

const QuestionPage = () => {
  const { t } = useTranslation()
  const { search } = useLocation()

  const _id = qs.parse(search.substring(1))._id as string

  const {
    data,
    isQuestionBeingFetched,
    isQuestionBeingSubmitted,
    isQuestionError,
    handleQuestionSubmission,
  } = useQuestion(_id)

  const question = data?.data[0] || null

  const renderQuestion = useMemo(() => {
    return (
      <Question
        question={question}
        isBeingFetched={isQuestionBeingFetched}
        isBeingSubmitted={isQuestionBeingSubmitted}
        handleQuestionSubmission={handleQuestionSubmission}
      />
    )
  }, [question, isQuestionBeingFetched, isQuestionBeingSubmitted])

  if (!_id || isQuestionError) {
    return <GenericError />
  }

  return (
    <AppSegment
      maxWidth="medium"
      centered
      headerProps={{
        text: t('question.header'),
        iconProps: { name: 'QUESTION_CIRCLE' },
        marginBottom: 'xsmall',
        rightSlot: (
          <QuestionContextMenu
            question={question}
            isDisabled={isQuestionBeingFetched || isQuestionBeingSubmitted}
            pointing="top right"
          />
        ),
      }}
    >
      {renderQuestion}
    </AppSegment>
  )
}

export default QuestionPage
